// Progressive enhancement for the theme's filter / sort <select>s (blog,
// archive, podcast, knowledge base, case studies).
//
// Goal: behave like the WooCommerce shop "sort by" dropdown — pick an option and
// it applies automatically — WITHOUT the accessibility problems of an inline
// onchange "jump menu":
//   * Mouse / touch: applies immediately on selection.
//   * Keyboard: applies on BLUR, not on every arrow-key change, so arrowing
//     through the options never triggers navigation (WCAG 2.1.1 Keyboard).
// There is no inline `onchange` attribute, so auditing tools do not read these
// as jump menus.

const SELECTOR = [
    'select[name="blog-order"]',      // archive / blog / podcast "sort by"
    '#archive-category-mobile',       // archive category filter (mobile)
    '#blog-category-mobile',          // blog category filter (mobile)
    '#case-studies__categories',      // case studies category filter
    '#case-studies__order-by',        // case studies "sort by"
    '#kb-product-category',           // knowledge base category filter
    '#installation-stage-select',     // KB article "jump to section"
].join(',');

function apply(select) {
    const value = select.value;
    if (!value || !value.trim()) {
        return;
    }
    const form = select.closest('form');
    if (form) {
        form.submit();
    } else {
        window.location.href = value;
    }
}

export default {
    init() {
        document.querySelectorAll(SELECTOR).forEach(function (select) {
            let pointer = false;
            let keyboardChanged = false;

            select.addEventListener('pointerdown', function () {
                pointer = true;
            });
            select.addEventListener('keydown', function () {
                pointer = false;
            });
            select.addEventListener('change', function () {
                if (pointer) {
                    pointer = false;
                    apply(select);
                } else {
                    // Keyboard change — wait until focus leaves before applying,
                    // so arrowing through options does not navigate.
                    keyboardChanged = true;
                }
            });
            select.addEventListener('blur', function () {
                if (keyboardChanged) {
                    keyboardChanged = false;
                    apply(select);
                }
            });
        });
    },
};
